import { QuizDialog } from "./QuizDialog";
import { useGetQuizResponse } from "./useGetQuizResponse";

type Props = {
  onDone: () => void;
  onClose: () => void;
  isOpen: boolean;
  quizResponseId: number;
};

export function QuizDialogContainer({
  onDone,
  onClose,
  isOpen,
  quizResponseId,
}: Props) {
  const { quiz, isLoading } = useGetQuizResponse({ quizResponseId });

  return (
    <QuizDialog
      onDone={onDone}
      onClose={onClose}
      isOpen={isOpen}
      isLoading={isLoading}
      quiz={quiz}
      quizResponseId={quizResponseId}
    />
  );
}

export default QuizDialogContainer;
